import Styled from "styled-components";

export const Container = Styled.div`
  padding: 2rem 0;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 4.6875rem 0;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    padding: 5.625rem 0;
  }
`;

export const Content = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
  }
`;

export const DesktopContent = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  padding: 4.5rem 4.5rem 0 4.5rem;
  border: 1px solid #E8E8E8;
  border-radius: 1rem;
  overflow: hidden;
`;

export const ValuePropositionCardContainer = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export interface IllustrationProps {
  $show: boolean;
}

export const Illustration = Styled.div<IllustrationProps>`
  display: none;
  width: 100%;
  height: auto;
  border-radius: 1rem 1rem 0 0;
  box-shadow: 0px 4px 24px -4px rgba(3, 3, 3, 0.24);

  .gatsby-image-wrapper {
    border-radius: 1rem 1rem 0 0;
  }

  ${(props) =>
    props.$show &&
    `
    display: block;
  `}
`;

export const SliderWrapper = Styled.div`
  display: flex;
  overflow: hidden;
  border-radius: 1rem;
  margin-bottom: 1.25rem;
`;

export interface SliderProps {
  $position: number;
}

export const Slider = Styled.div<SliderProps>`
  display: flex;
  width: 100%;
  transition: transform 0.5s ease;
  transform: translateX(${(props) => props.$position * -100}%);

  ${(props) => props.theme.breakpoints.up("medium")} {
    gap: 1.5rem;
    transform: translateX(${(props) => props.$position * -68}%);
  }
`;

export const CarouselIndicatorContainer = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

export interface CarouselIndicatorProps {
  $isActive: boolean;
}

export const CarouselIndicator = Styled.div<CarouselIndicatorProps>`
  width: 1.5rem;
  height: 0.25rem;
  background-color: ${(props) => props.theme.colors.neutrals.gray200};

  ${(props) =>
    props.$isActive &&
    `
    background-color: ${props.theme.colors.blue500};
  `}
`;
